import React, { useState, useMemo } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  PreviewAltCard,
  TooltipComponent,
} from "../../../components/Component";
import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { Link } from "react-router-dom";
import MyLoader from "../form/MyLoader";
import { UserAvatarCell } from "../../ImagePre/UserAvatarCell";
import Select from "react-select";
const Table = ({
  publicButton,
  nameColumn,
  isLoading,
  handleImageOpenPreview,
  resetF,
  isOpen,
  setIsOpen,
  title = "Data Table",
  data = [],
  columns = [],
  onEditClick,
  selectorCheck,
  onDeleteClick,

  onSelectChange,
  searchKeys,
  statusFilterEnabled = false,
  addButton = true,

  imageBaseURL = "",
  handleDeleteTreatment,
  handleToggleStatus,

  toggleCanvas,
  handleTogglePublish,
  approveRejectEnabled = false,
  handleApproveReject,
  medicineStatus,
  statusAction = true
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  // const [itemPerPage] = useState(5);
  const [itemPerPage, setItemPerPage] = useState(25);

  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  // console.log(data, "dta");
  // console.log(nameColumn,"nameColumn")

  const filteredData = useMemo(() => {
    let filtered = data;

    if (searchText.trim() !== "" && searchKeys.length > 0) {
      filtered = filtered.filter((item) =>
        searchKeys
          .map((key) => item[key])
          .join(" ")
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
    }
    if (statusFilterEnabled) {
      if (statusFilter === "active") filtered = filtered.filter((i) => i.status === true);
      else if (statusFilter === "InActive") filtered = filtered.filter((i) => i.status === false);
    }
    return filtered;
  }, [data, searchText, statusFilter]);

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleView = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const toggleModal = () => setModalOpen(!modalOpen);
  return (
    <div>
      <BlockHead className="mb-3" size="sm">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle>{title}</BlockTitle>
          </BlockHeadContent>
          <BlockHeadContent>
            <div className="nk-block-tools  me-3">
              <ul className="nk-block-tools g-3 align-items-center">
                <li>
                  <div className="form-control-wrap d-flex align-items-center">
                    <div className="form-icon form-icon-right">
                      <Icon name="search"></Icon>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`Search by  ${searchKeys?.join(", ")}`}
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ minWidth: "250px" }}
                    />
                  </div>
                </li>
                <li></li>

                {statusFilterEnabled && (
                  <li>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        color="transparent"
                        className="dropdown-toggle dropdown-indicator btn btn-outline-primary btn-white"
                      >
                        {statusFilter === "all" ? "All Status" : statusFilter === "active" ? "Active" : "InActive"}
                      </DropdownToggle>
                      <DropdownMenu end>
                        <ul className="link-list-opt no-bdr">
                          {["all", "active", "InActive"].map((v) => (
                            <li key={v}>
                              <DropdownItem onClick={() => setStatusFilter(v)}>
                                <span>{v.charAt(0).toUpperCase() + v.slice(1)}</span>
                              </DropdownItem>
                            </li>
                          ))}
                        </ul>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </li>
                )}

                {addButton && (
                  <li>
                    <div className="">
                      <Button
                        color="primary"
                        outline
                        className={`me-n1 bg-primary text-white`}
                        onClick={() => {
                          if (toggleCanvas) {
                            toggleCanvas();
                          } else {
                            setIsOpen(!isOpen);
                          }

                          resetF();
                        }}
                      // onClick={toggleCanvas}
                      >
                        <Icon name={isOpen ? "minus" : "plus"} />
                      </Button>
                    </div>
                  </li>
                )}
                <li>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      color="transparent"
                      className="dropdown-toggle dropdown-indicator btn btn-outline-primary btn-white"
                    >
                      Show {itemPerPage}
                    </DropdownToggle>

                    <DropdownMenu end>
                      {[25, 50, 100, 250].map((size) => (
                        <DropdownItem
                          key={size}
                          onClick={() => {
                            setItemPerPage(size);
                            setCurrentPage(1);
                          }}
                        >
                          {size} rows
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              </ul>
            </div>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>

      <Block
        className="table-wrapper"
        style={{
          background: "white",
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
          overflow: "hidden",
        }}
      >
        <div className="row nk-tb-list is-medium mb-3" style={{ background: "white" }}>
          <DataTableHead
            style={{
              background: "white",
              borderBottom: "1px solid #e5e9f2",
              fontWeight: "700",
            }}
          >
            {/* <DataTableRow className="nk-tb-col-check text-center">
              <div className="custom-control custom-control-sm custom-checkbox notext">
                <input type="checkbox" className="custom-control-input" onChange={selectorCheck} id="uid" />
                <label className="custom-control-label" htmlFor="uid"></label>
              </div>
            </DataTableRow> */}

            {columns.map((col) => (
              <DataTableRow key={col.key}>
                <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                  {col.label}
                </span>
              </DataTableRow>
            ))}
            {statusAction && (
              <DataTableRow className="text-center">
                <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                  Status
                </span>
              </DataTableRow>
            )}

            {!medicineStatus && (
              <DataTableRow className="text-center">
                <span style={{ fontWeight: "700", fontSize: "14px" }} className="sub-text">
                  Actions
                </span>
              </DataTableRow>
            )}


          </DataTableHead>

          {isLoading ? (
            // <PreviewAltCard className="d-flex justify-content-center">
            //   <div className="text-center">
            //     <MyLoader />
            //   </div>
            // </PreviewAltCard>
            null
          ) : (
            <>
              {currentItems.length > 0 ? (
                currentItems.map((item) => (
                  <DataTableItem key={item.id} className="hover-row align-middle W-25 text-start">
                    {/* <DataTableRow className="nk-tb-col-check text-center">
                  <div className="custom-control custom-control-sm custom-checkbox notext">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      checked={item.checked || false}
                      id={item.id + "_chk"}
                      onChange={(e) => onSelectChange(e, item.id)}
                    />
                    <label className="custom-control-label" htmlFor={item.id + "_chk"}></label>
                  </div>
                </DataTableRow> */}

                    {columns.map((col) => {
                      const getValue = (obj, path) => {
                        return path.split(".").reduce((acc, key) => (acc ? acc[key] : ""), obj);
                      };

                      const value = getValue(item, col.key);

                      return (
                        <DataTableRow key={col.key}>
                          {col.type === "image" ? (
                            <div className="d-flex align-items-center gap-2">
                              <UserAvatarCell row={col} image={`${imageBaseURL}${value}`} name={item[nameColumn]} handleImageOpenPreview={handleImageOpenPreview} />

                              {nameColumn && (
                                <span
                                  style={{
                                    fontWeight: "700",
                                    fontSize: "14px",
                                    color: "#364a63",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {item[nameColumn]}
                                </span>
                              )}
                            </div>
                          ) : (
                            <span style={{ fontWeight: "450" }}>{value || "-"}</span>
                          )}
                        </DataTableRow>
                      );
                    })}

                    <DataTableRow className="text-center">
                      {approveRejectEnabled && handleApproveReject && (
                        <div style={{ width: "80px", margin: "0 auto" }}>
                          {/* <Select
                            options={[
                              { value: "approved", label: "Approved" },
                              { value: "rejected", label: "Rejected" },
                              { value: "pending", label: "Pending" },
                            ]}
                            value={
                              // Automatically select the current status if it's 'approve' or 'reject'
                              item.status === "approved"
                                ? { value: "approved", label: "Approved" }
                                : item.status === "rejected"
                                  ? { value: "rejected", label: "Rejected" }
                                  : { value: "pending", label: "Pending" }
                            }
                            placeholder="Select Action"
                            onChange={(selectedOption) => handleApproveReject(item, selectedOption.value)}
                            isClearable
                            classNamePrefix="react-select"
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                minWidth: "150px",
                              }),
                              menu: (provided) => ({ ...provided, zIndex: 9999 }),
                            }}
                          /> */}
                          <Select
                            options={[
                              { value: "approved", label: "Approved" },
                              { value: "rejected", label: "Rejected" },
                              { value: "pending", label: "Pending" },
                            ]}
                            value={
                              item.status === "approved"
                                ? { value: "approved", label: "Approved" }
                                : item.status === "rejected"
                                  ? { value: "rejected", label: "Rejected" }
                                  : { value: "pending", label: "Pending" }
                            }

                            placeholder="Select Action"
                            onChange={(selectedOption) =>
                              handleApproveReject(item, selectedOption.value)
                            }
                            styles={{
                              container: (provided) => ({
                                ...provided,
                                minWidth: "150px",
                              }),

                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),

                              option: (provided, state) => {
                                let bgColor = "#fff";
                                let textColor = "#000";

                                if (state.data.value === "approved") {
                                  bgColor = "#28a745";
                                  textColor = "#fff";
                                }

                                if (state.data.value === "rejected") {
                                  bgColor = "#dc3545";
                                  textColor = "#fff";
                                }

                                if (state.data.value === "pending") {
                                  bgColor = "#ffc107";
                                  textColor = "#000";
                                }

                                return {
                                  ...provided,
                                  backgroundColor: state.isFocused ? bgColor : "#fff",
                                  color: state.isFocused ? textColor : "#333",
                                  fontWeight: "500",
                                };
                              },

                              singleValue: (provided, state) => {
                                const value = state.data.value;

                                let color = "#333";
                                if (value === "approved") color = "#28a745";
                                if (value === "rejected") color = "#dc3545";
                                if (value === "pending") color = "#ffc107";

                                return {
                                  ...provided,
                                  color,
                                  fontWeight: "600",
                                };
                              },
                            }}

                            theme={(baseTheme) => ({
                              ...baseTheme,
                              colors: {
                                ...baseTheme.colors,
                                primary: "#ee6677",
                                primary25: "#f0f0f0",
                                neutral0: "#fff",
                                neutral80: "#333",
                              },
                            })}
                          />
                        </div>
                      )}
                      {statusAction && (
                        <>
                          {!approveRejectEnabled && !handleApproveReject && (
                            <>
                              <span
                                onClick={() => handleToggleStatus(item)}
                                className={`fw-700 ${item.status ? "text-success" : "text-danger"}`}
                                style={{ cursor: "pointer", textTransform: "capitalize" }}
                              >
                                {item.status ? "Active" : "InActive"}
                              </span>
                            </>
                          )}
                        </>
                      )}


                      {/* <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(item)}>
            <Badge color={`${item.status ? "success" : "danger"}`}>{item.status ? "Active" : "InActive"}</Badge>
          </div> */}
                      {publicButton && (
                        <>
                          {" "}
                          <Button
                            outline
                            color={item?.isPublish ? `warning` : `success`}
                            size={`xs`}
                            className={`mx-1`}
                            onClick={() => handleTogglePublish(item)}
                            data-bs-toggle="tooltip"
                            title={item?.isPublish ? "Achieve Product" : "Publish Product"}
                          >
                            <Icon name={item?.isPublish ? "inbox-in" : "inbox-out"}></Icon>{" "}
                          </Button>
                        </>
                      )}{" "}
                    </DataTableRow>
                    {!medicineStatus && (
                      <DataTableRow className="text-center">
                        <ul className="nk-tb-actions gx-1 justify-content-center">
                          {/* <li
                          onClick={() => {
                            onEditClick(item);
                          }}
                          className="edit-icon"
                        >
                          <TooltipComponent
                            tag="a"
                            containerClassName="btn btn-icon btn-trigger btn-tooltip"
                            id={"edit" + item.id}
                            icon="edit-alt"
                            direction="top"
                            text="Edit"
                            onClick={toggleCanvas}
                            // onClick={() => onEditClick(item)}
                          />
                        </li> */}

                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                <Icon name="more-h"></Icon>
                              </DropdownToggle>
                              <DropdownMenu end>
                                <ul className="link-list-opt no-bdr">
                                  <li
                                    onClick={() => {
                                      onEditClick(item);
                                      // console.log(item, "itemid");
                                    }}
                                  >
                                    <DropdownItem>
                                      <div
                                        tag="a" href="#edit" onClick={(ev) => ev.preventDefault()}
                                        outline
                                        color="primary"
                                        size="s"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Edit"
                                      >
                                        <Icon name="edit me-1"></Icon>
                                        <span>Edit</span>
                                      </div>
                                    </DropdownItem>
                                  </li>
                                  {/* <li>
                                  <DropdownItem onClick={() => handleView(item)}>
                                    <div className="ms-1 ">
                                      <Icon name="eye" style={{ fontSize: "18px" }} />

                                      <span className="ms-2 " style={{ fontSize: "15px" }}>
                                        View
                                      </span>
                                    </div>
                                  </DropdownItem>
                                </li> */}
                                  {onDeleteClick && (
                                    <li>
                                      <DropdownItem onClick={() => handleDeleteTreatment(item)}>
                                        {/* <Link to="detailPage" state={{ item }} className="p-0 m-0 ps-0"> */}
                                        <div className="ms-1 ">
                                          <Icon name="trash" style={{ fontSize: "18px" }} />

                                          <span className="ms-1" style={{ fontSize: "15px" }}>
                                            Delete
                                          </span>
                                        </div>
                                        {/* </Link> */}
                                      </DropdownItem>
                                    </li>
                                  )}
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </DataTableRow>
                    )}
                  </DataTableItem>
                ))
              ) : (
                <div className=" d-flex justify-content-end align-items-center py-5 ">
                  <span>No records found</span>
                </div>
              )}
            </>
          )}

          {!isLoading && filteredData.length > 0 && (
            <PreviewAltCard className="border-top">
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={filteredData.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            </PreviewAltCard>
          )}
        </div>
      </Block>
      {isLoading && (
        <PreviewAltCard className="d-flex pe-2 me-2 ps-5 w-125 justify-content-center">
          <div className="text-center">
            <MyLoader />
          </div>
        </PreviewAltCard>
      )}
      <style>
        {`
          .hover-row {
            transition: background 0.2s ease;
          }
          .hover-row:hover {
            background: #f8f9fc;
          }
          .hover-row .edit-icon {
            opacity: 0;
            transition: opacity 0.2s ease;
          }
          .hover-row:hover .edit-icon {
            opacity: 1;
          }
          .nk-tb-list .nk-tb-item {
            border-bottom: 1px solid #f0f0f0;
          }
          .nk-tb-list .nk-tb-item:last-child {
            border-bottom: none;
          }
        `}
      </style>
    </div>
  );
};

export default Table;